import { render, staticRenderFns } from "./ImpactBoard.vue?vue&type=template&id=5679c21c&scoped=true"
import script from "./ImpactBoard.vue?vue&type=script&lang=ts"
export * from "./ImpactBoard.vue?vue&type=script&lang=ts"
import style0 from "./ImpactBoard.vue?vue&type=style&index=0&id=5679c21c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5679c21c",
  null
  
)

export default component.exports